import { useToast } from '@/context/ToastProvider';
import { SearchBox } from './SearchBox';

interface TopbarProps {
	onToggleMenu: () => void;
	isMenuOpen: boolean;
}

export function Topbar({ onToggleMenu, isMenuOpen }: TopbarProps) {
	const { notify } = useToast();

	return (
		<header className="sticky top-0 z-30 -mx-[4.2%] flex h-[70px] items-center justify-between gap-4 bg-bg/80 px-[4.2%] backdrop-blur-lg min-[700px]:h-[83px]">
			<button
				type="button"
				onClick={onToggleMenu}
				aria-label="Mở menu"
				aria-expanded={isMenuOpen}
				aria-controls="app-sidebar"
				className="grid size-[38px] shrink-0 place-items-center rounded-[11px] border border-transparent text-[19px] transition hover:border-line hover:bg-surface-2 min-[700px]:hidden"
			>
				☰
			</button>

			<SearchBox />

			<div className="flex shrink-0 items-center gap-3.5">
				<button
					type="button"
					onClick={() => notify('Bạn không có thông báo mới', 'info')}
					aria-label="Thông báo"
					className="relative grid size-[38px] place-items-center rounded-[11px] border border-transparent text-[19px] transition hover:border-line hover:bg-surface-2"
				>
					♧
					<em className="absolute top-0.5 right-0.5 size-[7px] rounded-full border-2 border-bg bg-accent" />
				</button>

				<div className="flex items-center gap-2.5 font-semibold text-white">
					<img
						src="https://i.pravatar.cc/80?img=47"
						alt="Ảnh đại diện"
						className="size-[34px] rounded-full border-2 border-accent"
					/>
					<span className="hidden min-[700px]:inline">Hikari⌄</span>
				</div>
			</div>
		</header>
	);
}
